import Vue from 'vue'
import Router from 'vue-router'
import login from '@/pages/login'
import deal_data from '@/pages/deal_data'
import index from '@/pages/index'
import login_new from '@/pages/login_new'
import index_new from '@/pages/index_new'


Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'login_new',
    component: login_new,
  },{
    path:'/deal_data',
    name:'deal_data',
    component:deal_data
  },{
    path:'/index',
    name:'index',
    component:index
  },{
    path:'/login_new',
    name:'login_new',
    component:login_new
  },{
    path:'/index_new',
    name:'index_new',
    component:index_new
  },
  // {		//404
  //   path: '*',
  //   component: NotFound
  // }, //全不匹配的情况下，返回404，路由按顺序从上到下，依次匹配。最后一个*能匹配全部，
];

const router = new Router({
	routes
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js